// @ts-ignore
import Moment from 'react-moment';
import moment from 'moment';
import React from 'react';
import { Table, Tag, Card, Tooltip } from 'antd';
import { ClockCircleOutlined, UserOutlined, HomeOutlined } from '@ant-design/icons';

function TableSubjectOnDayViewTypeGroupByDate(props) {
    const renderScheduleItem = (schedule, sessionColor) => {
        if (!schedule) {
            return <div className="text-center text-gray-400 py-4">-</div>;
        }

        const isExam = schedule.examId || schedule['subjectTeachingName']?.includes('[');

        // Extract content within brackets from subjectTeachingName
        let examLabel = '[Kiểm tra]';
        if (isExam && schedule['subjectTeachingName']) {
            const match = schedule['subjectTeachingName'].match(/\[([^\]]+)\]/);
            if (match && match[0]) {
                examLabel = match[0]; // Keep the brackets [...] with the content
            }
        }

        return (
            <Card
                size="small"
                className={`mb-2 last:mb-0 ${isExam ? 'border-red-300 bg-red-50' : 'border-gray-200'} hover:shadow-md transition-shadow`}
                bordered
            >
                {isExam && (
                    <div className="mb-2">
                        <Tag color="red" className="text-xm">
                            {examLabel}
                        </Tag>
                    </div>
                )}
                <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <HomeOutlined className="text-blue-600" />
                        <Tag color="blue" className="text-xs m-0 break-words whitespace-normal">
                            {schedule['roomName']}
                        </Tag>
                    </div>
                    <div className="flex items-center gap-2">
                        <UserOutlined className="text-green-600" />
                        <Tag color="green" className="text-xs m-0 break-words whitespace-normal">
                            {schedule['teacherName']}
                        </Tag>
                    </div>
                    <div className="flex items-center gap-2">
                        <ClockCircleOutlined className="text-orange-600" />
                        <Tag color={sessionColor} className="text-xs m-0 whitespace-normal">
                            {moment(schedule.startDateTime).format('HH:mm')} - {moment(schedule.endDateTime).format('HH:mm')}
                        </Tag>
                    </div>
                </div>
            </Card>
        );
    };

    const renderSessionCell = (schedules, sessionColor, bgColor) => {
        if (!schedules || schedules.length === 0 || !schedules[0]) {
            return <div className="text-center text-gray-400 py-4">-</div>;
        }

        return (
            <div className={`${bgColor} min-h-[60px] p-2`}>
                {schedules.map((schedule, idx) => (
                    schedule && (
                        <React.Fragment key={`schedule-${idx}`}>
                            {renderScheduleItem(schedule, sessionColor)}
                        </React.Fragment>
                    )
                ))}
            </div>
        );
    };

    const columns = [
        {
            title: <div className="text-center font-bold">Khoa</div>,
            dataIndex: 'facultyName',
            key: 'facultyName',
            fixed: 'left',
            width: 150,
            render: (text) => (
                <div className="font-semibold text-gray-800 text-xs">
                    {text}
                </div>
            ),
        },
        {
            title: <div className="text-center font-bold">Môn học</div>,
            dataIndex: 'subjectName',
            key: 'subjectName',
            fixed: 'left',
            width: 120,
            render: (text) => (
                <div className="font-semibold text-gray-800 text-xs">
                    {text}
                </div>
            ),
        },
        {
            title: <div className="text-center font-bold">Lớp</div>,
            dataIndex: 'subjectTeachingName',
            key: 'subjectTeachingName',
            fixed: 'left',
            width: 150,
            render: (text) => (
                <div className="font-semibold text-blue-700 text-xs">
                    {text}
                </div>
            ),
        },
        {
            title: (
                <div className="text-center font-bold">
                    <Tooltip title="Sáng">
                        <div>Sáng</div>
                    </Tooltip>
                </div>
            ),
            dataIndex: 'morning',
            key: 'morning',
            width: 200,
            render: (schedules) => renderSessionCell(schedules, 'blue', 'bg-blue-50'),
        },
        {
            title: (
                <div className="text-center font-bold">
                    <Tooltip title="Chiều">
                        <div>Chiều</div>
                    </Tooltip>
                </div>
            ),
            dataIndex: 'afternoon',
            key: 'afternoon',
            width: 200,
            render: (schedules) => renderSessionCell(schedules, 'orange', 'bg-orange-50'),
        },
        {
            title: (
                <div className="text-center font-bold">
                    <Tooltip title="Tối">
                        <div>Tối</div>
                    </Tooltip>
                </div>
            ),
            dataIndex: 'night',
            key: 'night',
            width: 200,
            render: (schedules) => renderSessionCell(schedules, 'green', 'bg-green-50'),
        },
    ];

    // Transform data for table - support both old and new data structure
    const items = props.data?.items || props.data || [];
    const tableData = items.map((item, index) => ({
        key: index,
        facultyName: item.facultyName,
        subjectName: item.subjectName,
        subjectTeachingName: item.subjectTeachingName,
        morning: item.seasons[0]?.morning || [],
        afternoon: item.seasons[0]?.afternoon || [],
        night: item.seasons[0]?.night || [],
    }));

    return (
        <div className="">
            {items.length > 0 ? (
                <Card
                    title={
                        <div className="text-center">
                            <h3 className="text-2xl font-bold text-gray-800 m-0">
                                📅 LỊCH HỌC NGÀY {moment(props.dateChoose).format('DD/MM/YYYY')}
                            </h3>
                            <p className="text-sm text-gray-600 mt-1">
                                {moment(props.dateChoose).format('dddd')}
                            </p>
                        </div>
                    }
                    className="shadow-lg"
                >
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        pagination={false}
                        scroll={{ x: 'max-content', y: 550 }}
                        size="small"
                        bordered
                        sticky
                        className="custom-schedule-table"
                    />
                    <style>{`
                        .custom-schedule-table .ant-table-thead > tr > th {
                            background: #059669 !important;
                            color: white !important;
                            font-weight: bold;
                            text-align: center;
                            position: sticky !important;
                            top: 0 !important;
                            z-index: 10 !important;
                        }
                        .custom-schedule-table .ant-table-cell {
                            padding: 8px !important;
                            vertical-align: top !important;
                        }
                    `}</style>
                </Card>
            ) : (
                <Card className="shadow-md">
                    <div className="text-center text-gray-500 py-8">
                        <div className="text-4xl mb-4">📅</div>
                        <div className="text-lg font-medium">Không có dữ liệu lịch học!</div>
                    </div>
                </Card>
            )}
        </div>
    );
}

export default TableSubjectOnDayViewTypeGroupByDate;
